export function renderImage(image?: string | JSX.Element) {
  if (!image) return null

  return typeof image === 'string' ? (
    <img src={image} key={image} alt="" />
  ) : (
    <>{image}</>
  )
}
